module.exports = __webpack_public_path__ + "static/media/no-avatar.f8f9beee.png";